import { ApolloProvider } from "@apollo/react-hooks";
import axios from "axios";
import React from "react";
import { Redirect, Switch } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import client from "./app/apollo_client";
import { PrivateRoute } from "./app/elements";
import DocumentsDetailPage from "./app/enrollment/pages/DocumentsDetailPage";
import EnrollmentDetailPage from "./app/enrollment/pages/EnrollmentDetailPage";
import HealthDetailPage from "./app/health/pages/HealthDetailPage";
import * as pages from "./app/pages";
import CreateEmailTaskPage from "./app/pages/EmailTask/CreateEmailTaskPage";
import ListEmailTaskPage from "./app/pages/EmailTask/ListEmailTaskPage";
import ImportsPage from "./app/pages/imports/ImportsPage";
import "./app/register-fa-icons";
import InviteProcessPage from "./app/v2/invite/pages/InviteProcessPage";
import "./assets/css/main.css";
import TransferProcessListPage from "./app/v2/transfers/pages/TransferProcessListPage";
import TransferProcessFormPage from "./app/v2/transfers/pages/TransferProcessFormPage";
import TransferProcessConvokedPage from "./app/v2/transfers/pages/TransferProcessConvokedPage";
import TransferApplicationListPage from "./app/v2/transfers/pages/TransferApplicationListPage";
import TransferApplicationDocumentReviewPage from "./app/v2/transfers/pages/TransferApplicationDocumentReviewPage";
import TransferApplicationAcademicReviewPage from "./app/v2/transfers/pages/TransferApplicationAcademicReviewPage";
import UserState from "./app/v2/common/states/UserState";

class Main extends React.Component {
  constructor( props ) {
    super( props )
    const token = localStorage.getItem( "token" )
    if ( token ) {
      this.token = token
      axios.defaults.headers.common.Authorization = `JWT ${token}`
    } else {
      delete axios.defaults.headers.common.Authorization
    }
  }

  render () {
    const { token } = this
    return (
      <>
        <ApolloProvider client={client}>
          <UserState>
            <Switch>
              <PrivateRoute path="/aguarde" component={pages.WaitingProject} />
              <PrivateRoute
                navbar
                exact
                path="/financers"
                component={pages.Financers}
              />
              <PrivateRoute
                navbar
                path="/financers/:token"
                component={pages.FinancerSummary}
              />
              <PrivateRoute
                navbar
                exact
                path="/academic"
                component={pages.DocumentsPage}
              />
              <PrivateRoute
                navbar
                path="/academic/:token"
                component={DocumentsDetailPage}
              />
              <PrivateRoute
                navbar
                path="/v2/financers/:token"
                component={EnrollmentDetailPage}
              />
              <PrivateRoute
                navbar
                exact
                path="/health"
                component={pages.HealthPage}
              />
              <PrivateRoute
                navbar
                path="/health/:token"
                component={HealthDetailPage}
              />
              <PrivateRoute
                navbar
                path="/enrollments"
                component={pages.Enrollments}
              />
              <PrivateRoute
                navbar
                path="/onboarding"
                component={pages.Onboarding}
              />
              <PrivateRoute navbar path="/importacao" component={ImportsPage} />
              <PrivateRoute
                navbar
                path="/dashboard"
                component={pages.DashboardPage}
              />
              <PrivateRoute
                navbar
                exact
                path="/naap"
                component={pages.NAAPPage}
              />
              <PrivateRoute
                navbar
                path="/naap/:token"
                component={pages.NAAPDetailsPage}
              />
              <PrivateRoute
                navbar
                path="/invite"
                component={InviteProcessPage}
                permission="invites.view_menu_convocacao"
              />
              <PrivateRoute
                navbar
                path="/emails/new"
                component={CreateEmailTaskPage}
              />
              <PrivateRoute navbar path="/emails" component={ListEmailTaskPage} />
              <PrivateRoute
                navbar
                exact
                path="/contracts"
                component={pages.PendingContractsPage}
              />
              <PrivateRoute
                navbar
                exact
                path="/reports"
                component={pages.ReportsPage}
              />
              <PrivateRoute
                navbar
                exact
                path="/reports/sql"
                component={pages.SQLReportListPage}
              />
              <PrivateRoute
                navbar
                exact
                path="/reports/sql/new"
                component={pages.SQLReportFormPage}
              />
              <PrivateRoute
                navbar
                exact
                path="/reports/sql/:id"
                component={pages.SQLReportDetailPage}
              />
              <PrivateRoute
                navbar
                exact
                path="/reports/sql/view/:id"
                component={pages.SQLReportViewPage}
              />
              {/* Transferência. {{{ */}
              <PrivateRoute
                navbar
                exact
                permission="transfers.view_transferprocess"
                path="/transferencias/processos"
                component={TransferProcessListPage}
              />
              <PrivateRoute
                navbar
                exact
                permission="transfers.add_transferprocess"
                path="/transferencias/processos/new"
                component={TransferProcessFormPage}
              />
              <PrivateRoute
                navbar
                exact
                permission="transfers.change_transferprocess"
                path="/transferencias/processos/:id"
                component={TransferProcessFormPage}
              />
              <PrivateRoute
                navbar
                exact
                permission="transfers.view_transferapplication"
                path="/transferencias/processos/:id/convocados"
                component={TransferProcessConvokedPage}
              />
              <PrivateRoute
                navbar
                exact
                permission="transfers.view_transferapplication"
                path="/transferencias/aplicacoes/documental"
                component={TransferApplicationListPage}
              />
              <PrivateRoute
                navbar
                exact
                permission="transfers.view_transferapplication"
                path="/transferencias/aplicacoes/academico"
                component={TransferApplicationListPage}
              />
              <PrivateRoute
                navbar
                exact
                permission="transfers.view_transferapplication"
                path="/transferencias/aplicacoes/:token/analise-documental"
                component={TransferApplicationDocumentReviewPage}
              />
              <PrivateRoute
                navbar
                exact
                permission="transfers.view_transferapplication"
                path="/transferencias/aplicacoes/:token/analise-academica"
                component={TransferApplicationAcademicReviewPage}
              />
              {/* }}} */}
              <Redirect to={token ? "/dashboard" : "/login"} />
            </Switch>
          </UserState>
        </ApolloProvider>
      </>
    )
  }
}

export default Main
